import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Overlay,
  Tooltip,
  Spinner,
  Image,
} from "react-bootstrap";
import classes from "./signUp.module.css";
import { NavLink, useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import "./signUp.module.css";
import SweetAlert from "../commonComponents/SweetAlert";
import NewSweetAlert from "react-bootstrap-sweetalert";
import logo from "../../Assets/Images/LogoColored.png";
import IVerifyMobile from "./SignUpOtpModal/OTP/VerifyMobile";

class SignUp extends Component {
  constructor() {
    super();
    this.target = null;
    this.state = {
      type: "password",
      passwordUnmatch: false,
      show: false,
      email: "",
      signUpStatus: false,
      readOnly: true,
      signUpErrorMsgStatus: false,
      signUpExtErrStatus: false,
      emFullNameErrMsg: "",
      emEmailErrMsg: "",
      emPasswordErrMsg: "",
      mobileNumber: "",
      otpshow: false,
      userType: null,
    };
  }

  hideAlert = () => {
    this.props.history.push("/login");
  };

  gotoHome = () => {
    window.open("https://www.foxmatrix.com/");
  };
  componentWillReceiveProps(nextProps) {
    if (this.state.signUpStatus !== nextProps.signUpStatus) {
      this.setState({
        signUpStatus: nextProps.signUpStatus,
        otpshow: true,
      });
    }
    if (this.state.signUpErrorMsgStatus !== nextProps.signUpErrorMsgStatus) {
      this.setState({
        signUpErrorMsgStatus: nextProps.signUpErrorMsgStatus,
      });
    } else if (this.state.signUpExtErrStatus !== nextProps.signUpExtErrStatus) {
      this.setState({
        signUpExtErrStatus: nextProps.signUpExtErrStatus,
      });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    var isValid = true;
    const bodyFormData = {
      name: event.target.fullName.value,
      mobileNumber: event.target.mobileNumber.value,
      email: event.target.email.value,
      password: event.target.password.value,
      confirmPassword: event.target.confirmPassword.value,
      candidateUserType: parseInt(this.state.userType),
    };
    if (
      event.target.mobileNumber.value === "" &&
      event.target.fullName.value === "" &&
      event.target.email.value === "" &&
      event.target.password.value === ""
    ) {
      this.setState({
        mobileNumberErrMsg: "Enter a Mobile number",
        emEmailErrMsg: "Enter an Email ID",
        emFullNameErrMsg: "Enter Full Name",
        emPasswordErrMsg: "Enter a Password",
      });
    } else if (!/^[a-zA-Z\s]+$/.test(event.target.fullName.value)) {
      this.setState({
        emFullNameErrMsg: "Please enter a valid Full Name",
      });
    } else if (!/[1-9]{1}[0-9]{9}/.test(event.target.mobileNumber.value)) {
      this.setState({
        mobileNumberErrMsg: "Please enter a valid Mobile Number",
      });
    } else if (!/\S+@\S+\.\S+/.test(event.target.email.value)) {
      this.setState({
        emEmailErrMsg: "Please enter a valid Email ID",
      });
    } else if (!event.target.password.value.length) {
      this.setState({
        emPasswordErrMsg: "Please enter a password",
      });
    } else if (
      !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/.test(
        event.target.password.value
      )
    ) {
      this.setState({
        emPasswordErrMsg:
          "Password should be between 8-15 characters with atleast one upper case,lower case,one digit and one special character.",
        confirmPasswordErrMsg: "",
      });
    } else {
      if (event.target.password.value === event.target.confirmPassword.value) {
        this.setState({
          passwordUnmatch: false,
          show: false,
          email: event.target.email.value,
        });
        this.props.onSignUpFormSubmission(bodyFormData);
      } else {
        this.setState({
          passwordUnmatch: true,
          show: true,
          email: "",
        });
      }
    }
  };

  passwordFormatChangedHandler = () => {
    if (this.state.type === "password") {
      this.setState({
        type: "text",
      });

      document.getElementById("password").classList.add("fa-eye");
      document.getElementById("password").classList.remove("fa-eye-slash");
    } else {
      this.setState({
        type: "password",
      });
      document.getElementById("password").classList.remove("fa-eye");
      document.getElementById("password").classList.add("fa-eye-slash");
    }
  };

  hide = () => {
    this.setState({
      passwordUnmatch: false,
      show: false,
    });
  };

  passwordLength = (e, len2) => {
    if (e.target.value.length >= len2 && e.which !== 8) {
      e.preventDefault();
    }
  };

  closeModalVerify = () => {
    this.setState({ otpshow: false, signUpStatus: false });
    this.props.history.push("/login");
    this.props.resetSignupSate();
  };
  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.history.location.search);
    const userType = urlParams.get("userType");
    this.setState({ userType: userType });
  }
  render() {
    const style = "borderBottom: 'red'";

    return (
      <div className={classes.Background}>
        <Container fluid>
          {!this.state.signUpStatus ? (
            <Row>
              <Col md={6}></Col>
              <Col md={6} style={{ marginTop: "1%" }}>
                <Card style={{ width: "28rem" }}>
                  <Card.Body>
                    <Card.Title
                      className="text-center"
                      style={{ color: "#52aa9d", padding: "2px" }}
                    >
                      <Image
                        width="200px"
                        src={logo}
                        alt="Logo"
                        fluid
                        onClick={this.gotoHome}
                        style={{ cursor: "pointer" }}
                      />

                      {/* <h5 style={{color:"#000",marginTop:"13px"}}>Self Assessment</h5> */}
                    </Card.Title>
                    <span className={classes.Startext}>
                      <span style={{ color: "red" }}>* </span> All fields are
                      mandatory.
                    </span>
                    <Form
                      onSubmit={(e) => this.handleSubmit(e)}
                      id="employerForm"
                    >
                      <div className="container" style={{ marginTop: "1rem" }}>
                        <div className="row">
                          <div style={{ width: "97%" }}>
                            <label className="has-float-label">
                              <input
                                type="text"
                                placeholder=" "
                                name="fullName"
                                autoComplete="off"
                                maxLength="50"
                                onClick={() =>
                                  this.setState({ readOnly: false })
                                }
                                onInput={() =>
                                  this.setState({ emFullNameErrMsg: "" })
                                }
                              />
                              <span>Full Name</span>
                            </label>
                            <span
                              className={classes.Validation}
                              style={{ top: "42.4%" }}
                            >
                              &nbsp;{this.state.emFullNameErrMsg}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div
                        className="container my-5"
                        style={{ marginTop: "4rem!important" }}
                      >
                        <div className="row">
                          <div style={{ width: "97%", marginTop: "-45px" }}>
                            <label className="has-float-label">
                              <input
                                type="number"
                                placeholder=" "
                                name="mobileNumber"
                                autoComplete="off"
                                // maxLength="52"
                                onClick={() =>
                                  this.setState({ readOnly: false })
                                }
                                onInput={() =>
                                  this.setState({ mobileNumberErrMsg: "" })
                                }
                                maxLength="10"
                              />
                              <span>Mobile Number</span>
                            </label>
                            <span
                              className={classes.Validation}
                              style={{ top: "53.5%" }}
                            >
                              &nbsp;{this.state.mobileNumberErrMsg}
                            </span>
                            <label
                              className="has-float-label"
                              style={{ marginTop: "1rem" }}
                            >
                              <input
                                type="text"
                                placeholder=" "
                                name="email"
                                onClick={() =>
                                  this.setState({ readOnly: false })
                                }
                                autoComplete="off"
                                readOnly={this.state.readOnly}
                                maxLength="50"
                                onInput={() =>
                                  this.setState({ emEmailErrMsg: "" })
                                }
                              />
                              <span>Email ID</span>
                            </label>
                            <span
                              className={classes.Validation}
                              style={{ top: "65.5%" }}
                            >
                              &nbsp;{this.state.emEmailErrMsg}
                            </span>
                          </div>
                        </div>
                      </div>
                      <Row style={{ marginTop: "-42px" }}>
                        <Col>
                          <label className="has-float-label">
                            <input
                              type={this.state.type}
                              id="_password"
                              placeholder=" "
                              onChange={this.hide}
                              autoComplete="off"
                              name="password"
                              readOnly={this.state.readOnly}
                              style={
                                this.state.passwordUnmatch
                                  ? { borderBottom: "1px solid red" }
                                  : null
                              }
                              onClick={() => this.setState({ readOnly: false })}
                              onKeyDown={(e) => this.passwordLength(e, 15)}
                              onInput={() =>
                                this.setState({ emPasswordErrMsg: "" })
                              }
                            />
                            <span>Password</span>
                          </label>
                          <span
                            className={classes.Validation}
                            style={{ top: "64%", left: "6%", width: "400px" }}
                          >
                            &nbsp;{this.state.emPasswordErrMsg}
                          </span>
                          <span
                            toggle="#password-field"
                            className={`fa fa-fw fa-eye-slash ${classes.fieldIcon} toggle-password`}
                            id="password"
                            onClick={this.passwordFormatChangedHandler}
                            ref={(target) => {
                              this.target = target;
                            }}
                          ></span>
                        </Col>
                        <Col>
                          <label className="has-float-label">
                            <input
                              type={this.state.type}
                              id="_confirmpassword"
                              placeholder=" "
                              autoComplete="off"
                              name="confirmPassword"
                              onChange={this.hide}
                              style={
                                this.state.passwordUnmatch
                                  ? { borderBottom: "1px solid red" }
                                  : null
                              }
                              onKeyDown={(e) => this.passwordLength(e, 15)}
                            />
                            <span>Confirm Password</span>
                          </label>
                          {this.state.show ? (
                            <span
                              className={classes.Validation}
                              style={{ top: "64%", left: "6%", width: "400px" }}
                            >
                              &nbsp;Passwords didn't match
                            </span>
                          ) : null}

                          {/* <Overlay target={this.target} show={this.state.show} placement="right">
                                                        {props => (
                                                            <Tooltip id="overlay-example" {...props}>
                                                                Passwords didn't match
                                                        </Tooltip>
                                                        )}
                                                    </Overlay> */}
                        </Col>
                      </Row>

                      <div
                        className="text-center"
                        style={{
                          fontWeight: "500 !important",
                          marginTop: "8px",
                        }}
                      >
                        <Button
                          className={`text-center mt-3 ${classes.Button}`}
                          type="submit"
                          variant="primary"
                          onClick={() => this.setState({ readOnly: false })}
                        >
                          Sign Up
                        </Button>
                        {this.props.signUpLoader ? (
                          <div style={{ margin: "-35px 0px 0px 252px" }}>
                            <Spinner
                              animation="border"
                              variant="warning"
                              role="status"
                            ></Spinner>
                          </div>
                        ) : (
                          ""
                        )}
                        <div style={{ marginTop: "15px" }}>
                          <span style={{ fontSize: "12px", color: "grey" }}>
                            Existing User?{" "}
                          </span>
                          <NavLink to="../login">
                            <span
                              style={{ color: "#fbb03b", fontWeight: "bold" }}
                            >
                              {" "}
                              Login
                            </span>
                          </NavLink>
                        </div>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ) : (
            ""
          )}

          {/* {
                     true?
                     <div>
                       <VerifyEmailAfterLoginModal />
                    </div>

                     :null
                 } */}

          {this.props.resendEmailErrorStatus ? (
            <NewSweetAlert
              style={{ width: "400px", marginLeft: "-210px" }}
              warning
              onConfirm={this.hideAlert}
              confirmBtnStyle={{
                background: "#fbb03b",
                borderRadius: "50px",
                width: "100px",
                border: "none",
                padding: "0.375rem 0.75rem",
              }}
            >
              {this.props.resendEmailErrorMsg}
            </NewSweetAlert>
          ) : null}
          {this.state.signUpErrorMsgStatus ? (
            <SweetAlert
              type="danger"
              show="true"
              msg={this.props.signUpErrorMsg}
            />
          ) : null}
          {this.state.signUpExtErrStatus ? (
            <SweetAlert type="danger" show="true" msg="Network Error" />
          ) : null}

          {this.props.signUpStatus ? (
            <IVerifyMobile
              show={this.state.otpshow}
              email={this.state.email}
              mobileNumber={this.state.mobileNumber}
              closeModalVerify={this.closeModalVerify}
            />
          ) : null}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    resendEmailStatus: state.employeeReducer.resendEmailStatus,
    resendEmailErrorStatus: state.employeeReducer.resendEmailErrorStatus,
    resendEmailErrorMsg: state.employeeReducer.resendEmailErrorMsg,
    resendEmailLoader: state.employeeReducer.resendEmailLoader,

    signUpStatus: state.employeeReducer.signUpStatus,
    signUpErrorMsg: state.employeeReducer.signUpErrorMsg,
    signUpLoader: state.employeeReducer.signUpLoader,
    signUpExtErr: state.employeeReducer.signUpExtErr,
    signUpErrorMsgStatus: state.employeeReducer.signUpErrorMsgStatus,
    signUpExtErrStatus: state.employeeReducer.signUpExtErrStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSignUpFormSubmission: (formData) =>
      dispatch(actionTypes.getSignUp(formData)),
    resendSignUpEmail: (email) =>
      dispatch(actionTypes.resendSignUpEmail(email)),
    resetSignupSate: () => dispatch(actionTypes.resetSignupSate()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignUp));
